import moment from "moment";

export function subtractBusinessDays (holidays: string[], date: moment.Moment, days: number): moment.Moment {
  const weekends = [0, 6];
  let daysRemaining = days;
  const newDate = date;

  while (daysRemaining > 0) {
    newDate.add(-1, "days");
    if (!weekends.includes(newDate.day()) && !holidays.includes(newDate.format("YYYY-MM-DD"))) {
      daysRemaining--;
    }
  }
  return newDate;
}

export function addBusinessDays (holidays: string[], date: moment.Moment, days: number): moment.Moment {
  const weekends = [0, 6];
  let daysRemaining = days;
  const newDate = date;

  while (daysRemaining > 0) {
    newDate.add(1, "days");
    if (!weekends.includes(newDate.day()) && !holidays.includes(newDate.format("YYYY-MM-DD"))) {
      daysRemaining--;
    }
  }
  return newDate;
}